import styled from 'styled-components'

const MyDiv = styled.div`
//  .page_wrapper {
//      padding-top: 8px;
     
//   }

  .page_heading {
    margin-bottom: 16px;
  }

  .flex_header {
    justify-content: space-between;
    align-items: center;
    flex-wrap: wrap;
  }
.page_heading {
  margin-bottom: 16px;
  }
 .icon_btn {
  min-width: 40px;
  cursor: pointer;
    
  }
.flex_header {
    justify-content: space-between;
    align-items: center;
    flex-wrap: wrap;
  }
.btn{
 background-color: #006838;
  color: white;
  border-radius: 6px;
  padding: 8px 8px;
  &:hover {
    background-color: #006838;
    color: white;
  }
.table_header {
    background-color: #f9fafb !important;
  }
 .empId {
    text-decoration: underline;
    color: rgba(0, 122, 255, 1);
    display: inline-flex;
    align-items: center;
    padding: 4px 8px; 
    border-radius: 16px;
    cursor: pointer;
    white-space: nowrap; 
  }
.action{
text-decoration: underline;
color: rgba(0, 122, 255, 1);

align-items: center;
cursor: pointer;
}

`
export default MyDiv